// extracted by mini-css-extract-plugin
export default {"gridContainer":"style_gridContainer__FQc4D","singleImg":"style_singleImg__C0qmr","borderGradient":"style_borderGradient__lnwnC"};